export interface ICustomerInfo {
    customerName?: string;
    customerPhone?: string;
    customerEmail?: string;
}

const customerInfoLocalStorageKey = 'customerInfo';

export function updateCustomerInfo(newCustomerInfo: ICustomerInfo): void {
    localStorage.setItem(customerInfoLocalStorageKey, JSON.stringify(newCustomerInfo));
}

export function getCustomerInfo(): ICustomerInfo | null {
    const customerInfo = localStorage.getItem(customerInfoLocalStorageKey);
    if (customerInfo) {
        // clear the customerInfo from localStorage after retrieving it
        localStorage.removeItem(customerInfoLocalStorageKey);
        return JSON.parse(customerInfo) as ICustomerInfo;
    }
    return null;
}

declare global {
    interface Window {
        updateCustomerInfo?: (newCustomerInfo: ICustomerInfo) => void;
    }
}

window.updateCustomerInfo = updateCustomerInfo;
